<template>
  <TitleFrame text="事後アンケート">
    <template slot="contents">
      <div class="ans-area">
        <div v-if="qid === 0">
          <p>事後アンケートは、回答受付を終了しました。</p>
<!--          <p>本日は、実証実験へご参加いただきありがとうございました。最後に、以下のアンケートにお答えください。全ての質問にご回答いただいた方に薄謝（AMAZONギフト券Eメールタイプ500円）を進呈いたします。謝礼をEメールで送付いたしますので、メールアドレスをお間違いなく記入いただくようご注意ください。（グループでのご旅行の場合には、代表の方についてお答えください。）</p>-->
<!--          <p>下のボタンをタップすると、事後アンケートのページに移動します。</p>-->
<!--          <TextLink text="事後アンケートに回答" @click-text="onCkickAnswers" />-->
        </div>
        <div v-if="qid === 1">
          <FormulateForm
            v-model="formData1"
            @submit="submitHandler"
          >
            <FormulateInput
              v-for="item in items1"
              :key="'1' + item.name"
              v-bind="item"
              :validation-messages="{required: '必須項目です'}"
            />
          </FormulateForm>
        </div>
        <div v-else-if="qid === 2">
          <FormulateForm
            v-model="formData2"
            @submit="submitHandler"
          >
            <div v-for="item in items2" :key="'2' + item.name">
              <FormulateInput
                v-bind="item"
                :validation-messages="{required: '必須項目です'}"
              />
              <FormulateInput
                v-if="formData2[item.name]==='その他'"
                type="text"
                name="whygohomeoth"
                label="その他の理由を記入してください"
                validation="required"
                :validation-messages="{required: '必須項目です'}"
                error-behavior="live"
              />
            </div>
          </FormulateForm>
        </div>
        <div v-else-if="qid === 3">
          <div class="big-bold-text">１箇所目の立ち寄り先について教えてください</div>
          <FormulateForm
            v-model="formData3"
            @submit="submitHandler"
          >
            <div v-for="item in items3" :key="'3' + item.name">
              <FormulateInput
                v-bind="item"
                :validation-messages="{required: '必須項目です'}"
              />
              <FormulateInput
                v-if="containOth(formData3[item.name])"
                type="text"
                :name="item.name + 'oth'"
                label="その他の理由を記入してください"
                validation="required"
                :validation-messages="{required: '必須項目です'}"
                error-behavior="live"
              />
            </div>
          </FormulateForm>
        </div>
        <div v-else-if="qid === 4">
          <div class="big-bold-text">２箇所目の立ち寄り先について教えてください</div>
          <FormulateForm
            v-model="formData4"
            @submit="submitHandler"
          >
            <div v-for="item in items3" :key="'4' + item.name">
              <FormulateInput
                v-bind="item"
                :validation-messages="{required: '必須項目です'}"
              />
              <FormulateInput
                v-if="containOth(formData4[item.name])"
                type="text"
                :name="item.name + 'oth'"
                label="その他の理由を記入してください"
                validation="required"
                :validation-messages="{required: '必須項目です'}"
                error-behavior="live"
              />
            </div>
          </FormulateForm>
        </div>
        <div v-else-if="qid === 5">
          <div class="big-bold-text">３箇所目の立ち寄り先について教えてください</div>
          <FormulateForm
            v-model="formData5"
            @submit="submitHandler"
          >
            <div v-for="item in items3" :key="'5' + item.name">
              <FormulateInput
                v-bind="item"
                :validation-messages="{required: '必須項目です'}"
              />
              <FormulateInput
                v-if="containOth(formData5[item.name])"
                type="text"
                :name="item.name + 'oth'"
                label="その他の理由を記入してください"
                validation="required"
                :validation-messages="{required: '必須項目です'}"
                error-behavior="live"
              />
            </div>
          </FormulateForm>
        </div>
        <div v-else-if="qid === 6">
          <FormulateForm
            v-model="formData6"
            @submit="submitHandler"
          >
            <FormulateInput
              v-for="item in items6"
              :key="'6' +item.name"
              v-bind="item"
              :validation-messages="{required: '必須項目です'}"
            />
          </FormulateForm>
        </div>
        <div v-else-if="qid === 7">
          <div class="thank-you">事後アンケートのご回答、ありがとうございました。実験期間終了後、ご記入いただいたメールに謝礼（AMAZONギフト券Eメールタイプ500円分）を送付いたします。
          <TextLink text="トップに戻る" @click-text="onCkickGotoTop" />
          </div>
        </div>
      </div>
    </template>
  </TitleFrame>
</template>

<script>

import { mapState, mapMutations } from 'vuex'
import TitleFrame from '@/components/Templates/TitleFrame'
import SelectBox from '@/components/Atoms/SelectBox'
import TextLink from '@/components/Atoms/TextLink'
import Firebase from './../../firebase'

export default {
  name: 'settings',
  components: {
    SelectBox,
    TitleFrame,
    TextLink
  },
  computed: {
    ...mapState(['isAgreed', 'isAnswered', 'uid', 'FinalQAnswerd']),
    coockieUid () {
      return this.$cookies.get('uid')
    }
  },
  data () {
    return {
      qid: 0,
      formData1: {},
      formData2: {},
      formData3: {},
      formData4: {},
      formData5: {},
      formData6: {},
      items1: [
        {
          type: 'text',
          name: 'email',
          label: 'メールアドレス',
          validation: 'required'
        },
        {
          type: 'radio',
          name: 'person',
          label: 'あなたも含めて、何人でのご旅行ですか。※子供や乳幼児も含む',
          options: [
            { value: '1人', id: 'person1', label: '1人' },
            { value: '2人', id: 'person2', label: '2人' },
            { value: '3人', id: 'person3', label: '3人' },
            { value: '4人', id: 'person4', label: '4人' },
            { value: '5人', id: 'person5', label: '5人' },
            { value: '6人', id: 'person6', label: '6人以上' }
          ],
          validation: 'required'
        }, {
          type: 'radio',
          name: 'children',
          label: '同行者の中に小学生以下の子供がいますか？',
          options: [
            { value: 'いる', id: 'children1', label: 'いる' },
            { value: 'いない', id: 'children2', label: 'いない' }
          ],
          validation: 'required'
        }, {
          type: 'radio',
          name: 'elder',
          label: '同行者の中に65才以上の高齢者がいますか？',
          options: [
            { value: 'いる', id: 'elder1', label: 'いる' },
            { value: 'いない', id: 'elder2', label: 'いない' }
          ],
          validation: 'required'
        }, {
          type: 'radio',
          name: 'travelType',
          label: '今回のご旅行は日帰りですか、宿泊ですか？',
          options: [
            { value: '日帰り', id: 'travelType1', label: '日帰り' },
            { value: '宿泊', id: 'travelType2', label: '宿泊' }
          ],
          validation: 'required'
        }, {
          type: 'radio',
          name: 'firstTime',
          label: '八ヶ岳観光圏への訪問は今回が初めてですか？',
          options: [
            { value: '初めて', id: 'firstTime1', label: '初めて' },
            { value: '２回目', id: 'firstTime2', label: '２回目' },
            { value: '３回目以上', id: 'firstTime3', label: '３回目以上' }
          ],
          validation: 'required'
        }, {
          type: 'checkbox',
          name: 'expect',
          label: '「スイスイ旅」に期待した主な機能は何ですか（複数選択可）',
          options: [
            { value: '観光施設・店舗の情報の提供', id: 'expect1', label: '観光施設・店舗の情報の提供' },
            { value: '施設・店舗で実施しているコロナ対策情報の提供', id: 'expect2', label: '施設・店舗で実施しているコロナ対策情報の提供' },
            { value: '施設・店舗の混雑状況情報の提供', id: 'expect3', label: '施設・店舗の混雑状況情報の提供' }
          ],
          validation: 'required'
        }, {
          type: 'checkbox',
          name: 'timing',
          label: '今回のご旅行で「スイスイ旅」を使用したたタイミング（当てはまるものをすべて選んでください）',
          options: [
            { value: '観光中', id: 'timing1', label: '観光中' },
            { value: '観光地への到着前', id: 'timing2', label: '観光地への到着前' },
            { value: '観光旅行出発前', id: 'timing3', label: '観光旅行出発前' }
          ],
          validation: 'required'
        }, {
          type: 'radio',
          name: 'visit',
          label: '「スイスイ旅」を利用した後に訪問した観光先・飲食店等についてお答えください。「スイスイ旅」を利用した後にどこかに立ち寄りました？',
          options: [
            { value: 'どこにも立ち寄らなかった', id: 'visit1', label: 'どこにも立ち寄らなかった' },
            { value: '1箇所に立ち寄った', id: 'visit2', label: '1箇所に立ち寄った' },
            { value: '2箇所に立ち寄った', id: 'visit3', label: '2箇所に立ち寄った' },
            { value: '3箇所以上に立ち寄った', id: 'visit4', label: '3箇所以上に立ち寄った' }
          ],
          validation: 'required'
        }, {
          name: 'submit',
          type: 'submit',
          label: '次へ'
        }
      ],
      items2: [
        {
          type: 'radio',
          name: 'whygohome',
          label: 'どこにも立ち寄らず直接帰宅した理由を教えてください。(複数選択可)',
          options: [
            { value: 'すぐに出発した方が所要時間が短いから', id: 'whygohome1', label: 'すぐに出発した方が所要時間が短いから' },
            { value: '多少所要時間が長くても、すぐに出発した方が早く着くから', id: 'whygohome2', label: '多少所要時間が長くても、すぐに出発した方が早く着くから' },
            { value: '渋滞があっても気にしないから', id: 'whygohome3', label: '渋滞があっても気にしないから' },
            { value: '立ち寄りたい場所がないから', id: 'whygohome4', label: '立ち寄りたい場所がないから' },
            { value: '夜の運転を避けたいから', id: 'whygohome5', label: '夜の運転を避けたいから' },
            { value: 'その他', id: 'whygohome6', label: 'その他' }
          ],
          'validation-name': '入力必須項目です',
          validation: 'required'
        }, {
          name: 'submit',
          type: 'submit',
          label: '次へ'
        }
      ],
      items3: [
        {
          type: 'radio',
          name: 'spotType1',
          label: '立ち寄った施設の種類を以下の中から選んで教えてください。',
          options: [
            { value: '飲食店', id: 'spotType11', label: '飲食店' },
            { value: '買い物', id: 'spotType12', label: '買い物' },
            { value: '観光スポット（アクティビティ、公園等を含む）', id: 'spotType13', label: '観光スポット（アクティビティ、公園等を含む）' },
            { value: '温泉', id: 'spotType14', label: '温泉' },
            { value: 'その他', id: 'spotType15', label: 'その他' }
          ],
          validation: 'required'
        },
        {
          type: 'text',
          name: 'spotName1',
          label: '立ち寄った施設名・店名を教えてください。',
          validation: 'required'
        },
        {
          type: 'radio',
          name: 'spotPlan',
          label: '該当立ち寄り先は事前に計画した観光先ですか？',
          options: [
            { value: 'はい', id: 'spotPlan1', label: 'はい' },
            { value: 'いいえ', id: 'spotPlan2', label: 'いいえ' }
          ],
          validation: 'required'
        },
        {
          type: 'checkbox',
          name: 'drop1',
          label: '該当施設・店舗に立ち寄った主な理由を教えてください。（複数選択可）',
          options: [
            { value: '施設・店舗の魅力を感じ訪問したいから', id: 'drop11', label: '施設・店舗の魅力を感じ訪問したいから' },
            { value: '混雑していないから', id: 'drop12', label: '混雑していないから' },
            { value: 'コロナ対策を講じているから', id: 'drop13', label: 'コロナ対策を講じているから' },
            { value: 'その他', id: 'drop14', label: 'その他' }
          ],
          validation: 'required'
        },
        {
          type: 'time',
          name: 'time1',
          label: '立寄り先に到着したおおよその時刻を記憶の範囲で教えてください。',
          validation: 'required'
        },
        {
          type: 'select',
          name: 'spendTime1',
          label: '立寄り先での滞在時間を教えてください。',
          options: [
            { value: '30分', id: 'spendTime11', label: '30分' },
            { value: '1時間', id: 'spendTime12', label: '1時間' },
            { value: '1時間30分', id: 'spendTime13', label: '1時間30分' },
            { value: '2時間', id: 'spendTime14', label: '2時間' },
            { value: '2時間30分', id: 'spendTime15', label: '2時間30分' },
            { value: '3時間以上', id: 'spendTime16', label: '3時間以上' }
          ],
          validation: 'required'
        },
        {
          type: 'number',
          name: 'spotMoney1',
          label: '立ち寄った施設で消費した一人あたりのおよその金額を教えてください。',
          validation: 'required'
        },
        {
          name: 'submit',
          type: 'submit',
          label: '次へ'
        }
      ],
      items6: [
        {
          type: 'radio',
          name: 'refered',
          label: '混雑状況の情報は、立ち寄り先を決定するための参考になったと思いますか？',
          options: [
            { value: 'そう思います', id: 'refered1', label: 'そう思います' },
            { value: 'ややそう思います', id: 'refered2', label: 'ややそう思います' },
            { value: 'そう思あまりそう思いませんいます', id: 'refered3', label: 'あまりそう思いません' },
            { value: '全くそう思いません', id: 'refered4', label: '全くそう思いません' },
            { value: 'よくわかりません', id: 'refered5', label: 'よくわかりません' }
          ]
        },
        {
          type: 'radio',
          name: 'refered2',
          label: 'コロナ対策の情報提供は、立ち寄り先を決定するための参考になったと思いますか？',
          options: [
            { value: 'そう思います', id: 'refered21', label: 'そう思います' },
            { value: 'ややそう思います', id: 'refered22', label: 'ややそう思います' },
            { value: 'あまりそう思いません', id: 'refered23', label: 'あまりそう思いません' },
            { value: '全くそう思いません', id: 'refered24', label: '全くそう思いません' },
            { value: 'よくわかりません', id: 'refered25', label: 'よくわかりません' }
          ]
        },
        {
          type: 'select',
          name: 'spotRate',
          label: '「スイスイ旅」で提示した立寄り施設情報の満足度を10段階で評価してください。（10はとても満足している）',
          placeholder: '選択してください',
          options: [
            { value: '10', id: 'spotRate10', label: '10' },
            { value: '9', id: 'spotRate9', label: '9' },
            { value: '8', id: 'spotRate8', label: '8' },
            { value: '7', id: 'spotRate7', label: '7' },
            { value: '6', id: 'spotRate6', label: '6' },
            { value: '5', id: 'spotRate5', label: '5' },
            { value: '4', id: 'spotRate4', label: '4' },
            { value: '3', id: 'spotRate3', label: '3' },
            { value: '2', id: 'spotRate2', label: '2' },
            { value: '1', id: 'spotRate1', label: '1' }
          ],
          validation: 'required'
        },
        {
          type: 'text',
          name: 'want',
          label: '立ち寄り先の情報について、他にも欲しい情報がありましたら、教えてください。'
        },
        {
          type: 'select',
          name: 'appRate',
          label: '「スイスイ旅」の満足度を10段階で評価してください。10はとても満足している）',
          placeholder: '選択してください',
          options: [
            { value: '10', id: 'appRate10', label: '10' },
            { value: '9', id: 'appRate9', label: '9' },
            { value: '8', id: 'appRate8', label: '8' },
            { value: '7', id: 'appRate7', label: '7' },
            { value: '6', id: 'appRate6', label: '6' },
            { value: '5', id: 'appRate5', label: '5' },
            { value: '4', id: 'appRate4', label: '4' },
            { value: '3', id: 'appRate3', label: '3' },
            { value: '2', id: 'appRate2', label: '2' },
            { value: '1', id: 'appRate1', label: '1' }
          ],
          validation: 'required'
        },
        {
          type: 'text',
          name: 'any',
          label: '感想・コメントなどを自由に記入してください。'
        },
        {
          name: 'submit',
          type: 'submit',
          label: '提出'
        }
      ],
      answers: []
    }
  },
  methods: {
    ...mapMutations(['loadingStart', 'loadingEnd']),
    containOth (e) {
      if (e && Array.isArray(e)) {
        return e.filter(x => x === 'その他').length
      } else if (e) return e === 'その他'
      else return 0
    },
    onCkickAnswers (e) {
      navigator.geolocation.getCurrentPosition(function (position) {
        Firebase.putLog({
          ActionType: 'SeeLastQ',
          CurrentLatLon: {
            current_lat: position.coords.latitude,
            current_lon: position.coords.longitude
          }
        })
      },
      function (err) {
        var msgs = [
          err.message,
          '位置情報の取得を許可されていません。',
          '位置情報の取得に失敗しました。',
          '位置情報を取得中にタイムアウトしました。'
        ]
        window.alert(msgs[err.code])
      },
      { maximumAge: 0 })
      Firebase.finalQShown()
      this.qid = 1
    },
    onCkickGotoTop (e) {
      this.$router.push({name: 'RouteSearch'})
    },
    scrollTotop () {
      var divElement = document.getElementById('content-area')
      divElement.scrollTop = 0
    },
    submitHandler (e) {
      if (this.qid === 1) {
        if (this.formData1.visit === 'どこにも立ち寄らなかった') this.qid = 2
        else if (this.formData1.visit === '1箇所に立ち寄った') this.qid = 3
        else if (this.formData1.visit === '2箇所に立ち寄った') this.qid = 3
        else if (this.formData1.visit === '3箇所以上に立ち寄った') this.qid = 3
        this.answers.push({data: this.formData1, item: this.items1})
        this.scrollTotop()
      } else if (this.qid === 2) {
        this.qid = 6
        this.answers.push({data: this.formData2, item: this.items2})
        this.scrollTotop()
      } else if (this.qid === 3) {
        if (this.formData1.visit === '2箇所に立ち寄った') this.qid = 4
        else if (this.formData1.visit === '3箇所以上に立ち寄った') this.qid = 4
        else this.qid = 6
        this.answers.push({data: this.formData3, item: this.items3, type: 'spot1_'})
        this.scrollTotop()
      } else if (this.qid === 4) {
        if (this.formData1.visit === '3箇所以上に立ち寄った') this.qid = 5
        else this.qid = 6
        this.answers.push({data: this.formData4, item: this.items3, type: 'spot2_'})
        this.scrollTotop()
      } else if (this.qid === 5) {
        this.qid = 6
        this.answers.push({data: this.formData5, item: this.items3, type: 'spot3_'})
        this.scrollTotop()
      } else if (this.qid === 6) {
        this.answers.push({data: this.formData6, item: this.items6})
        Firebase.putLastAnswers(this.answers)

        navigator.geolocation.getCurrentPosition(function (position) {
          Firebase.putLog({
            ActionType: 'AnswerLastQ',
            CurrentLatLon: {
              current_lat: position.coords.latitude,
              current_lon: position.coords.longitude
            }
          })
        },
        function (err) {
          var msgs = [
            err.message,
            '位置情報の取得を許可されていません。',
            '位置情報の取得に失敗しました。',
            '位置情報を取得中にタイムアウトしました。'
          ]
          window.alert(msgs[err.code])
        },
        { maximumAge: 0 })
        Firebase.finalQAnswerd()
        this.qid = 7
      }
    }
  },
  watch: {
    isAnswered: {
      immideate: true,
      handler: function () {
        if (this.isAnswered) {
          // 回答済みならば実験参加画面へ
          this.$router.push({name: 'ExperimentAgree'})
        } else {
          // 未回答ならば回答画面を表示する
          this.loadingEnd()
        }
      }
    }
  },
  mounted () {
    this.loadingStart()
    if (!this.coockieUid || !this.uid) {
      this.$router.push({name: 'Consent'})
    }
    if (!this.isAgreed) {
      this.$router.push({name: 'Consent'})
    }
    if (!this.isAnswered) {
      this.$router.push({name: 'Consent'})
    }
    if (this.FinalQAnswerd) {
      this.qid = 7
    }
    this.loadingEnd()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import './../../unified.scss';

input{
  font-size: 16px;
}
.big-bold-text{
  font-size:1.5rem;
  font-weight:bold;
  margin:0.5rem 0rem;
}

.thank-you{
  margin: 10rem 0rem 0rem 0rem;
  text-align: center;
}
.ans-area{
  margin-bottom: 3rem;
}

.formulate-input{margin-bottom:1.5em;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol}.formulate-input .formulate-input-label{display:block;line-height:1.5;font-size:.9em;font-weight:600;margin-bottom:.1em}.formulate-input .formulate-input-label--before+.formulate-input-help--before{margin-top:-.25em;margin-bottom:.75em}.formulate-input .formulate-input-element{max-width:20em;margin-bottom:.1em}.formulate-input .formulate-input-help{color:#6d6d6d;font-size:.7em;font-weight:400;line-height:1.5;margin-bottom:.25em}.formulate-input .formulate-input-errors{list-style-type:none;padding:0;margin:0}.formulate-input .formulate-file-upload-error,.formulate-input .formulate-input-error{color:#960505;font-size:.8em;font-weight:300;line-height:1.5;margin-bottom:.25em}.formulate-input:last-child{margin-bottom:0}.formulate-input[data-classification=text] input{-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:.3em;border:1px solid #cecece;box-sizing:border-box;background-color:transparent;font-size:.9em;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;padding:.75em;display:block;width:100%;font-weight:400;line-height:1.2em;margin:0}.formulate-input[data-classification=text] input::-webkit-input-placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=text] input::-moz-placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=text] input:-ms-input-placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=text] input::-ms-input-placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=text] input::placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=text] input:focus{outline:0;border:1px solid #41b883}.formulate-input[data-classification=text] .formulate-input-element--date input,.formulate-input[data-classification=text] .formulate-input-element--datetime-local input,.formulate-input[data-classification=text] .formulate-input-element--month input,.formulate-input[data-classification=text] .formulate-input-element--week input{min-height:2.2em}.formulate-input[data-classification=text] .formulate-input-element--search{position:relative}.formulate-input[data-classification=text] .formulate-input-element--search:before{content:"";width:2em;height:100%;position:absolute;left:0;top:0;background-image:url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72.99 72.9"><path fill="%236d6d6d" d="M71.77,66,53.87,48.1A29.94,29.94,0,1,0,30,60a29.52,29.52,0,0,0,18.1-6.1l18,17.8A4,4,0,0,0,69,72.9a4.18,4.18,0,0,0,2.9-1.2A4.09,4.09,0,0,0,71.77,66ZM30.07,51.9a21.9,21.9,0,1,1,15.5-37.4A21.37,21.37,0,0,1,52,30a22,22,0,0,1-6.4,15.5A21.54,21.54,0,0,1,30.07,51.9Z"/></svg>');background-size:1em 1em;background-repeat:no-repeat;background-position:50%;pointer-events:none}.formulate-input[data-classification=text] .formulate-input-element--search input{padding-left:2em}.formulate-input[data-classification=text] input[type=color]{height:1.1em;box-sizing:content-box;width:auto;min-width:5em}.formulate-input[data-classification=text] input[type=color]::-webkit-color-swatch-wrapper{padding:0 0 0 1.5em;display:flex;align-items:center;background-image:url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 79.17 79.17"><path fill="%236d6d6d" d="M40.8,22.92c-3.4-3.4-4.76-8.44-1-12.24s8.84-2.44,12.24,1c5-5,10.69-13.33,18.81-11.31a11,11,0,0,1,7.62,14.34c-1.26,3.45-4.63,6.06-7.16,8.59-.92.93-3,2.26-3.46,3.46-.42,1,1.82,2.63,2.36,4a8,8,0,0,1-12.42,9.19c-.21-.16-1.35-1.51-1.59-1.51s-.83.83-1,1L49.71,44.9,32.43,62.18c-3.37,3.38-6.6,7.14-10.26,10.21a11,11,0,0,1-4.48,2.28c-1.25.3-3.11-.22-4.18.18-1.28.48-2.42,2.65-3.68,3.4-6.05,3.61-12.64-4-8.46-9.57.73-1,2.53-1.92,3-3a14.46,14.46,0,0,0-.09-2.52,10.75,10.75,0,0,1,3.14-6.77c.92-1,1.93-1.93,2.89-2.9Zm4.4-1.5c4.19,4,8.24,8.24,12.36,12.36,2.06,2.06,5,5.59,8,2.61,4.65-4.62-5-6.8-2.42-10.78C66.3,20.7,76.4,16.48,74.84,9.45,73.62,4,67.12,2.78,63.29,6.32c-2.55,2.36-4.93,4.94-7.39,7.4-.79.78-1.8,2.28-2.88,2.73-2.14.88-3.4-1.62-4.79-2.77-2.58-2.14-6.89-.82-6.53,3C41.89,18.68,43.87,20.09,45.2,21.42Zm-1.45,4.44L27.82,41.79C22,47.57,15.89,53.14,10.41,59.2a8.23,8.23,0,0,0-1.44,2c-.93,2,.25,4.14-.5,6S4.92,69.94,4.3,72a2.34,2.34,0,0,0,2.56,3c1.11-.17,2-1.33,2.71-2.07a11.17,11.17,0,0,1,2.08-2c1.68-.94,4,.17,5.93-.57C20,69.41,22,66.73,23.76,65L34.42,54.3,53.3,35.42Z"/></svg>');background-repeat:no-repeat;background-size:.9em .9em;background-position:left .1em}.formulate-input[data-classification=text] input[type=color]::-webkit-color-swatch{display:block;height:1em;border-radius:.2em;border:0;flex:auto}.formulate-input[data-classification=text] input[type=color]::-moz-color-swatch{display:block;height:1em;border-radius:.2em;border:0;flex:auto}.formulate-input[data-classification=slider] .formulate-input-element--range{display:flex;align-items:center}.formulate-input[data-classification=slider] .formulate-input-element-range-value{font-size:.9em;line-height:1;margin-left:.5em;background-color:#efefef;padding:.25em .3em;border-radius:.25em;color:#6d6d6d;font-variant-numeric:tabular-nums}.formulate-input[data-classification=slider] input{-webkit-appearance:none;-moz-appearance:none;appearance:none;width:100%;font-size:1em;padding:.5em 0}.formulate-input[data-classification=slider] input:focus{outline:0}.formulate-input[data-classification=slider] input::-webkit-slider-thumb{cursor:pointer;-webkit-appearance:none;appearance:none;width:1em;height:1em;border-radius:1em;border:0;background-color:#41b883;margin-top:calc(-.5em + 2px)}.formulate-input[data-classification=slider] input::-moz-range-thumb{cursor:pointer;-moz-appearance:none;appearance:none;width:1em;height:1em;border-radius:1em;border:0;background-color:#41b883;margin-top:calc(-.5em + 2px)}.formulate-input[data-classification=slider] input::-ms-thumb{cursor:pointer;appearance:none;width:1em;height:1em;border-radius:1em;border:0;background-color:#41b883;margin-top:calc(-.5em + 2px)}.formulate-input[data-classification=slider] input::-webkit-slider-runnable-track{-webkit-appearance:none;appearance:none;width:100%;height:4px;background-color:#efefef;border-radius:3px;margin:0;padding:0}.formulate-input[data-classification=slider] input::-moz-range-track{-moz-appearance:none;appearance:none;width:100%;height:4px;background-color:#efefef;border-radius:3px;margin:0;padding:0}.formulate-input[data-classification=textarea] textarea{-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:.3em;border:1px solid #cecece;box-sizing:border-box;background-color:transparent;font-size:.9em;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;padding:.75em;display:block;width:100%;font-weight:400;line-height:1.2em;margin:0}.formulate-input[data-classification=textarea] textarea::-webkit-input-placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=textarea] textarea::-moz-placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=textarea] textarea:-ms-input-placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=textarea] textarea::-ms-input-placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=textarea] textarea::placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=textarea] textarea:focus{outline:0;border:1px solid #41b883}.formulate-input[data-classification=button] button{-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:.3em;box-sizing:border-box;background-color:transparent;font-size:.9em;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;padding:.75em;display:block;width:100%;font-weight:400;line-height:1.2em;margin:0;border:1px solid #41b883;background-color:#41b883;color:#fff;min-width:0;width:auto;font-weight:700;cursor:pointer;display:inline-flex;align-items:center}.formulate-input[data-classification=button] button::-webkit-input-placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=button] button::-moz-placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=button] button:-ms-input-placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=button] button::-ms-input-placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=button] button::placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=button] button:focus{outline:0;border:1px solid #41b883}.formulate-input[data-classification=button] button[disabled]{background-color:#cecece;border-color:#cecece}.formulate-input[data-classification=button] button[data-ghost]{color:#41b883;background-color:transparent;border-color:currentColor}.formulate-input[data-classification=button] button[data-minor]{font-size:.75em;display:inline-block}.formulate-input[data-classification=button] button[data-danger]{background-color:#960505;border-color:#960505}.formulate-input[data-classification=button] button[data-danger][data-ghost]{color:#960505;background-color:transparent}.formulate-input[data-classification=button] button:active{background-color:#64c89b;border-color:#64c89b}.formulate-input[data-classification=select] .formulate-input-element{position:relative}.formulate-input[data-classification=select] .formulate-input-element:before{content:"";width:0;height:0;border-color:#cecece transparent transparent;border-style:solid;border-width:.3em .3em 0;top:50%;margin-top:-.1em;right:1em;position:absolute}.formulate-input[data-classification=select] select{-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:.3em;border:1px solid #cecece;box-sizing:border-box;background-color:transparent;font-size:.9em;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;display:block;width:100%;font-weight:400;line-height:1.2em;margin:0;padding:.75em 2em .75em .75em}.formulate-input[data-classification=select] select::-webkit-input-placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=select] select::-moz-placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=select] select:-ms-input-placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=select] select::-ms-input-placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=select] select::placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=select] select:focus{outline:0;border:1px solid #41b883}.formulate-input[data-classification=select] select[data-placeholder-selected]{color:#a8a8a8}.formulate-input[data-classification=box] .formulate-input-wrapper{display:flex;align-items:center}.formulate-input[data-classification=box] .formulate-input-element{overflow:hidden;display:flex;align-items:center}.formulate-input[data-classification=box] .formulate-input-element input{position:absolute;left:-999px;opacity:0;pointer-events:none}.formulate-input[data-classification=box] .formulate-input-element-decorator{display:block;width:1em;height:1em;border-radius:.25em;border:1px solid #cecece;position:relative}.formulate-input[data-classification=box] .formulate-input-element-decorator:before{content:"";display:block;background-size:contain;background-position:100%;width:calc(100% - .125em);height:calc(100% - .125em);box-sizing:border-box;position:absolute;top:.0625em;left:.0625em}.formulate-input[data-classification=box] .formulate-input-element[data-type=radio] .formulate-input-element-decorator{border-radius:1em}.formulate-input[data-classification=box] .formulate-input-element[data-type=radio] .formulate-input-element-decorator:before{border-radius:1em;width:calc(100% - .5em);height:calc(100% - .5em);top:.25em;left:.25em}.formulate-input[data-classification=box] .formulate-input-element input[type=checkbox]:checked~.formulate-input-element-decorator{border-color:#41b883}.formulate-input[data-classification=box] .formulate-input-element input[type=checkbox]:checked~.formulate-input-element-decorator:before{background-color:#41b883;-webkit-mask-image:url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M8.76,56.2c-6.38-6.34,3.26-16,9.64-9.69L38,65.88,80.56,23.29c6.38-6.38,16.07,3.32,9.69,9.69L42.84,80.37a6.83,6.83,0,0,1-9.65,0Z"/></svg>');mask-image:url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M8.76,56.2c-6.38-6.34,3.26-16,9.64-9.69L38,65.88,80.56,23.29c6.38-6.38,16.07,3.32,9.69,9.69L42.84,80.37a6.83,6.83,0,0,1-9.65,0Z"/></svg>')}.formulate-input[data-classification=box] .formulate-input-element input[type=radio]:checked~.formulate-input-element-decorator{border-color:#41b883}.formulate-input[data-classification=box] .formulate-input-element input[type=radio]:checked~.formulate-input-element-decorator:before{background-color:#41b883}.formulate-input[data-classification=box] .formulate-input-element input:focus~.formulate-input-element-decorator{border-color:#41b883}.formulate-input[data-classification=box] .formulate-input-label--after{margin-left:.5em}.formulate-input[data-classification=box] .formulate-input-label--before{margin-right:.5em}.formulate-input[data-classification=group] .formulate-input-group-item,.formulate-input[data-classification=group]>.formulate-input-wrapper>.formulate-input-label{margin-bottom:.5em}.formulate-input[data-classification=group] [data-is-repeatable]{padding:1em;border:1px solid #efefef;border-radius:.3em}.formulate-input[data-classification=group] [data-is-repeatable] .formulate-input-grouping{margin:-1em -1em 0}.formulate-input[data-classification=group] [data-is-repeatable] .formulate-input-group-repeatable{padding:1em 3em 1em 1em;border-bottom:1px solid #efefef;position:relative}.formulate-input[data-classification=group] [data-is-repeatable] .formulate-input-group-repeatable-remove{position:absolute;display:block;top:calc(50% - .15em);width:1.3em;height:1.3em;background-color:#cecece;right:.85em;border-radius:1.3em;cursor:pointer;transition:background-color .2s;overflow:hidden;text-indent:-1000px}.formulate-input[data-classification=group] [data-is-repeatable] .formulate-input-group-repeatable-remove:after,.formulate-input[data-classification=group] [data-is-repeatable] .formulate-input-group-repeatable-remove:before{content:"";position:absolute;top:calc(50% - .1em);left:.325em;display:block;width:.65em;height:.2em;background-color:#fff;transform-origin:center center;transition:transform .25s}@media (pointer:fine){.formulate-input[data-classification=group] [data-is-repeatable] .formulate-input-group-repeatable-remove:hover{background-color:#dc2c2c}.formulate-input[data-classification=group] [data-is-repeatable] .formulate-input-group-repeatable-remove:hover:after,.formulate-input[data-classification=group] [data-is-repeatable] .formulate-input-group-repeatable-remove:hover:before{height:.2em;width:.75em;left:.25em;top:calc(50% - .075em)}.formulate-input[data-classification=group] [data-is-repeatable] .formulate-input-group-repeatable-remove:hover:after{transform:rotate(45deg)}.formulate-input[data-classification=group] [data-is-repeatable] .formulate-input-group-repeatable-remove:hover:before{transform:rotate(-45deg)}}.formulate-input[data-classification=group] [data-is-repeatable] .formulate-input-group-repeatable:last-child{margin-bottom:1em}.formulate-input[data-classification=file] .formulate-input-upload-area{width:100%;position:relative;padding:2em 0}.formulate-input[data-classification=file] .formulate-input-upload-area input{cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;opacity:0;position:absolute;left:0;right:0;bottom:0;top:0;width:100%;height:100%;z-index:5}.formulate-input[data-classification=file] .formulate-input-upload-area[data-has-files]{padding:0}.formulate-input[data-classification=file] .formulate-input-upload-area[data-has-files] input{display:none}.formulate-input[data-classification=file] .formulate-input-upload-area-mask{border-radius:.4em;pointer-events:none;position:absolute;display:flex;justify-content:center;align-items:center;left:0;right:0;top:0;bottom:0;border:2px dashed #a8a8a8;z-index:2}.formulate-input[data-classification=file] .formulate-input-upload-area-mask:before{content:"";background-color:#a8a8a8;-webkit-mask-image:url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 58"><path d="M29,58A29,29,0,1,0,0,29,29,29,0,0,0,29,58ZM29,4A25,25,0,1,1,4,29,25,25,0,0,1,29,4Z"/><polygon points="27 22 27 44.4 31 44.4 31 22 41.7 31.1 44.3 28.1 29 15 13.7 28.1 16.3 31.1 27 22"/></svg>');mask-image:url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 58"><path d="M29,58A29,29,0,1,0,0,29,29,29,0,0,0,29,58ZM29,4A25,25,0,1,1,4,29,25,25,0,0,1,29,4Z"/><polygon points="27 22 27 44.4 31 44.4 31 22 41.7 31.1 44.3 28.1 29 15 13.7 28.1 16.3 31.1 27 22"/></svg>');-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-position:center;mask-position:center;width:2em;height:2em;position:absolute;pointer-events:none}.formulate-input[data-classification=file] .formulate-input-upload-area input:focus~.formulate-input-upload-area-mask,.formulate-input[data-classification=file] .formulate-input-upload-area input:hover~.formulate-input-upload-area-mask,.formulate-input[data-classification=file] .formulate-input-upload-area input[data-is-drag-hover]~.formulate-input-upload-area-mask{border-color:#41b883}.formulate-input[data-classification=file] .formulate-input-upload-area input:focus~.formulate-input-upload-area-mask:before,.formulate-input[data-classification=file] .formulate-input-upload-area input:hover~.formulate-input-upload-area-mask:before,.formulate-input[data-classification=file] .formulate-input-upload-area input[data-is-drag-hover]~.formulate-input-upload-area-mask:before{background-color:#41b883}.formulate-input[data-classification=file] .formulate-files{list-style-type:none;margin:0;padding:0}.formulate-input[data-classification=file] .formulate-files .formulate-file-progress{background-color:#cecece;height:.3em;border-radius:1.25em;width:5em;overflow:hidden;position:relative;flex:0 0 5em;right:.75em;transition:height .25s,width .25s,flex-basis .25s;z-index:2}.formulate-input[data-classification=file] .formulate-files .formulate-file-progress:before{content:"";position:absolute;top:0;left:0;right:0;bottom:0;display:block;opacity:0;transform:scale(.08);background-color:#fff;-webkit-mask-image:url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M8.76,56.2c-6.38-6.34,3.26-16,9.64-9.69L38,65.88,80.56,23.29c6.38-6.38,16.07,3.32,9.69,9.69L42.84,80.37a6.83,6.83,0,0,1-9.65,0Z"/></svg>');mask-image:url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M8.76,56.2c-6.38-6.34,3.26-16,9.64-9.69L38,65.88,80.56,23.29c6.38-6.38,16.07,3.32,9.69,9.69L42.84,80.37a6.83,6.83,0,0,1-9.65,0Z"/></svg>');-webkit-mask-size:77%;mask-size:77%;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-position:center;mask-position:center;z-index:3}.formulate-input[data-classification=file] .formulate-files .formulate-file-progress[data-just-finished]{width:1.25em;height:1.25em;flex:0 0 1.25em}.formulate-input[data-classification=file] .formulate-files .formulate-file-progress[data-just-finished]:before{transition:transform .25s .2s,opacity .25s .2s;transform:scale(1);opacity:1}.formulate-input[data-classification=file] .formulate-files .formulate-file-progress[data-is-finished]{transition:height .25s,width .25s,left .25s,top,.25s,border-radius .25s;width:.3em;flex:0 0 .3em;height:100%;right:0;border-radius:0 .23em .23em 0}.formulate-input[data-classification=file] .formulate-files .formulate-file-progress[data-is-finished]:before{transition:opacity .1s;opacity:0}.formulate-input[data-classification=file] .formulate-files .formulate-file-progress .formulate-file-progress-inner{background-color:#41b883;width:1%;position:absolute;left:0;bottom:0;top:0;z-index:2}.formulate-input[data-classification=file] .formulate-files .formulate-file-name{padding-left:1.5em;padding-right:2em;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.formulate-input[data-classification=file] .formulate-files .formulate-file-name:before{position:absolute;left:.7em;top:50%;margin-top:-.7em;background-color:#a8a8a8;content:"";-webkit-mask-image:url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64.06 83.59"><path d="M55.94,83.59a8.16,8.16,0,0,0,8.12-8.16V19.12a1.77,1.77,0,0,0-.52-1.25L46.21.59A1.69,1.69,0,0,0,45.14.08L44.69,0l-.18,0H8.13A8.18,8.18,0,0,0,0,8.16V75.41a8.16,8.16,0,0,0,8.13,8.16H55.94ZM46.68,6,58.11,17.38H46.68ZM3.52,75.43V8.16A4.64,4.64,0,0,1,8.13,3.52h35V19.16a1.75,1.75,0,0,0,1.76,1.74H60.55V75.43a4.65,4.65,0,0,1-4.61,4.65H8.13A4.65,4.65,0,0,1,3.52,75.43Z"/></svg>');mask-image:url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64.06 83.59"><path d="M55.94,83.59a8.16,8.16,0,0,0,8.12-8.16V19.12a1.77,1.77,0,0,0-.52-1.25L46.21.59A1.69,1.69,0,0,0,45.14.08L44.69,0l-.18,0H8.13A8.18,8.18,0,0,0,0,8.16V75.41a8.16,8.16,0,0,0,8.13,8.16H55.94ZM46.68,6,58.11,17.38H46.68ZM3.52,75.43V8.16A4.64,4.64,0,0,1,8.13,3.52h35V19.16a1.75,1.75,0,0,0,1.76,1.74H60.55V75.43a4.65,4.65,0,0,1-4.61,4.65H8.13A4.65,4.65,0,0,1,3.52,75.43Z"/></svg>');-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-size:contain;mask-size:contain;width:1.25em;height:1.25em;display:inline-block;margin-right:.5em}.formulate-input[data-classification=file] .formulate-files .formulate-file-remove{width:1.25em;height:1.25em;border-radius:1em;border:1px solid #a8a8a8;background-color:#a8a8a8;-webkit-mask-image:url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.1 59.2"><path d="M1.6,57.7a5,5,0,0,0,3.5,1.5,4.85,4.85,0,0,0,3.5-1.5l21-21,21,21a5,5,0,0,0,3.5,1.5,4.85,4.85,0,0,0,3.5-1.5,5,5,0,0,0,0-7.1l-21-21,21-21a5,5,0,0,0,0-7.1,5,5,0,0,0-7.1,0l-21,21L8.6,1.7a5,5,0,0,0-7.1,0,5,5,0,0,0,0,7.1l21,21L1.6,50.7A4.83,4.83,0,0,0,1.6,57.7Z"/></svg>');mask-image:url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.1 59.2"><path d="M1.6,57.7a5,5,0,0,0,3.5,1.5,4.85,4.85,0,0,0,3.5-1.5l21-21,21,21a5,5,0,0,0,3.5,1.5,4.85,4.85,0,0,0,3.5-1.5,5,5,0,0,0,0-7.1l-21-21,21-21a5,5,0,0,0,0-7.1,5,5,0,0,0-7.1,0l-21,21L8.6,1.7a5,5,0,0,0-7.1,0,5,5,0,0,0,0,7.1l21,21L1.6,50.7A4.83,4.83,0,0,0,1.6,57.7Z"/></svg>');-webkit-mask-size:.6em;mask-size:.6em;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-position:center;mask-position:center;cursor:pointer;position:absolute;right:.75em;z-index:1;transition:transform .25s}@media (pointer:fine){.formulate-input[data-classification=file] .formulate-files .formulate-file-remove:hover{transform:scale(1.5)}}.formulate-input[data-classification=file] .formulate-files li{display:block}.formulate-input[data-classification=file] .formulate-files li[data-has-error] .formulate-file-progress{background-color:#dc2c2c}.formulate-input[data-classification=file] .formulate-files li[data-has-preview] .formulate-file-name:before{display:none}.formulate-input[data-classification=file] .formulate-files li+li{margin-top:.5em}.formulate-input[data-classification=file] .formulate-files .formulate-file{-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:.3em;border:1px solid #cecece;box-sizing:border-box;background-color:transparent;font-size:.9em;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;padding:.75em;font-weight:400;line-height:1.2em;margin:0;display:block;width:100%;display:flex;justify-content:flex-start;align-items:center;position:relative}.formulate-input[data-classification=file] .formulate-files .formulate-file::-webkit-input-placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=file] .formulate-files .formulate-file::-moz-placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=file] .formulate-files .formulate-file:-ms-input-placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=file] .formulate-files .formulate-file::-ms-input-placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=file] .formulate-files .formulate-file::placeholder{color:#a8a8a8;line-height:normal}.formulate-input[data-classification=file] .formulate-files .formulate-file:focus{outline:0;border:1px solid #41b883}.formulate-input[data-classification=file] .formulate-files .formulate-file ::-webkit-progress-bar{-webkit-appearance:none;appearance:none;height:.5em;border-radius:.5em;overflow:hidden}.formulate-input[data-classification=file] .formulate-files .formulate-file-image-preview{width:3em;height:3em;flex:0 0 3em;position:relative;z-index:2;left:-1px;box-shadow:0 0 0 1px #efefef;transition:transform .25s,box-shadow .25s,background-color .25s}@media (pointer:fine){.formulate-input[data-classification=file] .formulate-files .formulate-file-image-preview:hover{transition-delay:.2s;transform:scale(3);background-color:#fff;box-shadow:0 0 2px 0 rgba(0,0,0,.1)}}.formulate-input[data-classification=file] .formulate-files .formulate-file-image-preview img{display:block;position:absolute;width:100%;height:100%;left:0;right:0;bottom:0;top:0;-o-object-fit:contain;object-fit:contain;transition:all .25s}.formulate-input[data-classification=file] [data-type=image] .formulate-input-upload-area .formulate-input-upload-area-mask:before{-webkit-mask-image:url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 71.05"><path d="M82.89,0H7.1A7.12,7.12,0,0,0,0,7.11V64a7.11,7.11,0,0,0,7.1,7.1H82.9A7.11,7.11,0,0,0,90,64V7.11A7.12,7.12,0,0,0,82.89,0ZM69.28,39.35a5.44,5.44,0,0,0-8,0L50.58,50.74,32.38,30.88a5.31,5.31,0,0,0-7.92,0L4.74,52.4V7.11A2.37,2.37,0,0,1,7.11,4.74H82.9a2.37,2.37,0,0,1,2.36,2.37V56.3Z"/><circle cx="67.74" cy="22.26" r="8.53"/></svg>');mask-image:url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 71.05"><path d="M82.89,0H7.1A7.12,7.12,0,0,0,0,7.11V64a7.11,7.11,0,0,0,7.1,7.1H82.9A7.11,7.11,0,0,0,90,64V7.11A7.12,7.12,0,0,0,82.89,0ZM69.28,39.35a5.44,5.44,0,0,0-8,0L50.58,50.74,32.38,30.88a5.31,5.31,0,0,0-7.92,0L4.74,52.4V7.11A2.37,2.37,0,0,1,7.11,4.74H82.9a2.37,2.37,0,0,1,2.36,2.37V56.3Z"/><circle cx="67.74" cy="22.26" r="8.53"/></svg>')}.formulate-form-errors{margin:.75em 0;padding:0;list-style-type:none}.formulate-form-errors:first-child{margin-top:0}.formulate-form-errors:last-child{margin-bottom:0}.formulate-form-errors .formulate-form-error{color:#960505;font-size:.9em;font-weight:300;line-height:1.5;margin-bottom:.25em}

</style>



// WEBPACK FOOTER //
// src/components/Pages/Answers.vue